import React from 'react'


function Navbar(props) {
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode} `}>
  <div className="container-fluid">
    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}

    <a className="navbar-brand" href="?">Navbar</a>
    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
      <span className="navbar-toggler-icon"></span>
    </button>
    <div className="collapse navbar-collapse" id="navbarNav">
      <ul className="navbar-nav">
        <li className="nav-item">
          <a className="nav-link active" aria-current="page" href="?">Home</a>
        </li>
        <li className="nav-item">
          <a className="nav-link" href="?">About</a>
        </li>
         
      </ul>
    </div>
    
  <div className={`form-check form-switch text-${props.mode === 'light'?'dark': 'light'}`} >
    <input className="form-check-input" type="checkbox" role="switch" onClick={props.toggleMode} id="flexSwitchCheckDefault"/>
    <label className="form-check-label" htmlFor="flexSwitchCheckDefault">Enable DarkMode</label>
</div>
  </div>
</nav>
  )
}
export default Navbar;

